import { ConfigurableCard } from "../components/ConfigurableCard";
import { useTemplateContext } from "../provider";
import { VerificationNames } from "shared/types";
import { Switch } from "shared/components/forms/Switch";
import { CheckComponent } from "../components/CheckComponent";

const MedicalLabel = () => (
  <>
    <p className="text-content-1000 text-sm font-medium">
      Exclude medical accounts from debt, past due, and collection calculation
    </p>
    <p className="text-content-400 font-normal text-sm mt-1">
      Medical accounts pulled from the credit report will not factor into Boom’s
      debt, past due, and collection calculations
    </p>
  </>
);

const StudentLabel = () => (
  <>
    <p className="text-content-1000 text-sm font-medium">
      Exclude student accounts from debt, past due, and collection calculation
    </p>
    <p className="text-content-400 font-normal text-sm mt-1">
      Student accounts pulled from the credit report will not factor into Boom’s
      debt, past due, and collection calculations
    </p>
  </>
);

export const CreditReportSlice = () => {
  const { readOnly, template, partnerType, setTemplate } = useTemplateContext();

  if (!template) return null;

  const toggleCreditReport = (
    key: "exclude_medical_debt" | "exclude_student_debt",
    toggle: boolean
  ) => {
    const updatedTemplate = {
      ...template,
      verification_schemas: {
        ...template.verification_schemas,
        [partnerType]: {
          ...template.verification_schemas[partnerType],
          [VerificationNames.CreditReport]: {
            ...template.verification_schemas[partnerType][
              VerificationNames.CreditReport
            ],
            [key]: toggle
          }
        }
      }
    };

    setTemplate(updatedTemplate);
  };

  const isHideCreditReportDisabled = !Boolean(
    template.verification_schemas[partnerType][VerificationNames.CreditReport]
  );

  return (
    <ConfigurableCard title="General settings">
      {readOnly ? (
        <>
          <CheckComponent
            checked={Boolean(
              template.verification_schemas[partnerType][
                VerificationNames.CreditReport
              ]?.exclude_medical_debt
            )}
            label={<MedicalLabel />}
          />

          <CheckComponent
            checked={Boolean(
              template.verification_schemas[partnerType][
                VerificationNames.CreditReport
              ]?.exclude_student_debt
            )}
            label={<StudentLabel />}
          />
        </>
      ) : (
        <>
          <Switch
            label={<MedicalLabel />}
            onChange={(v) => toggleCreditReport("exclude_medical_debt", v)}
            disabled={isHideCreditReportDisabled || readOnly}
            checked={Boolean(
              template.verification_schemas[partnerType][
                VerificationNames.CreditReport
              ]?.exclude_medical_debt
            )}
          />

          <Switch
            label={<StudentLabel />}
            onChange={(v) => toggleCreditReport("exclude_student_debt", v)}
            disabled={isHideCreditReportDisabled || readOnly}
            checked={Boolean(
              template.verification_schemas[partnerType][
                VerificationNames.CreditReport
              ]?.exclude_student_debt
            )}
          />
        </>
      )}
    </ConfigurableCard>
  );
};
